import { cdnApi } from '~config/api';

export const statementsService = {
  getStatement: file => cdnApi.get(`/statements/${file}`)
};
